import React, { Component } from "react";
import { MDBIcon, toast } from "mdbreact";
import "./MultiTenancy.css";

/**
 * Operator ID Display — Mockup #7
 *
 * Small reusable widget that shows the operator's unique Operator ID with a
 * copy-to-clipboard button. Suitable for the account / settings area and
 * inside the Secondary Operator permissions panel.
 *
 * Props:
 *   operatorId   - string
 *   operatorName - string (optional, displayed above the ID)
 *   description  - optional description override
 */
class OperatorIdDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = { copied: false };
    }

    handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(this.props.operatorId);
            this.setState({ copied: true });
            toast.success("Operator ID copied to clipboard", {
                closeButton: false,
            });
            setTimeout(() => this.setState({ copied: false }), 1500);
        } catch (err) {
            toast.error("Failed to copy", { closeButton: false });
        }
    };

    render() {
        const { operatorId, operatorName, description } = this.props;
        const { copied } = this.state;

        return (
            <div className="mt-operator-id-widget">
                {operatorName && (
                    <p className="mt-operator-id-name">
                        <strong>Operator: </strong>
                        {operatorName}
                    </p>
                )}

                <div className="mt-operator-id-card">
                    <div className="mt-operator-id-label">
                        Your Operator ID
                    </div>
                    <div className="mt-operator-id-value-row">
                        <span className="mt-operator-id-value">
                            {operatorId}
                        </span>
                        <button
                            type="button"
                            className="mt-copy-btn"
                            onClick={this.handleCopy}
                            title="Copy to clipboard"
                        >
                            {copied ? (
                                <>
                                    <MDBIcon icon="check" /> Copied
                                </>
                            ) : (
                                <>
                                    <MDBIcon icon="copy" /> Copy
                                </>
                            )}
                        </button>
                    </div>
                    <p className="mt-operator-id-help">
                        {description ||
                            "Share this ID with another VAULT operator to request them as a Secondary Operator for a venue you own."}
                    </p>
                </div>
            </div>
        );
    }
}

export default OperatorIdDisplay;
